<template>
    <footer :class="big">

      <div class="container" >




        <div class="customers-ticker-mob"  v-if="!big && isMobile" >
          <div class="customers-item-mob" v-for="(item, index) in newArr" :class="'customers-item' + index" >
            <img :src="item.logo" :alt="item.name">
          </div>

        </div>

        <div class="customers-ticker" :class="'numtiems' + actualArr.length" v-if="!big && !isMobile">
          <div class="customers-item" v-for="(item, index) in newArr" :class="'customers-item' + index" >
            <img :src="item.logo" :alt="item.name">
          </div>

        </div>



         <div v-if="big && !isMobile" class="customers-ticker-big">




           <div class="customers-ticker-big-cont" >
             <div class="customers-item" v-for="(item, index) in fixedArr" :class="'customers-item' + index"  :id="'icon' + index">


               <div class="inner-box" v-for="(item2, index2) in customersData"   :id="'inner' + index2">
                 <img :src="item2.logo" :alt="item2.name">

               </div>





             </div>
           </div>



         </div>

        <div v-if="big && isMobile" class="customers-ticker-big">


          <div class="customers-ticker-big-cont-mob" >
            <div class="customers-item-mob customers-item" v-for="(item, index) in customersData" :class="'customers-item' + index" >
              <img :src="item.logo" :alt="item.name">
            </div>
          </div>



        </div>

        <div class="agency-info">

          <div class="agency-info-left ani-footer1" style="opacity: 0;">


            <!--div class="agency-info-partners">
              <div class="agency-info-partners-item agency-info-partners-item1" style="opacity: 0;">
                <div>Duarte Durão</div>
                <div>Managing Partner</div>
              </div>

              <div class="agency-info-partners-item agency-info-partners-item2" style="opacity: 0;">
                <div>Nuno Cardoso</div>
                <div>Creative Partner</div>
              </div>

              <div class="agency-info-partners-item agency-info-partners-item3" style="opacity: 0;">
                <div>Vasco Teixeira-Pinto</div>
                <div>Digital Partner</div>
              </div>

            </div-->

            <div class="agency-info-tags">
              <div class="agency-info-tags-logo">
                <Icons :id="'NOSSA'"></Icons>
              </div>



              <div class="agency-info-tags-item" v-for="(item, index) in tags" v-on:click="goPage(item.name[lang].name )">{{item.name[lang].name}}</div>
              <div class="agency-info-tags-item" v-on:click="goAgencgy()">Estratégia</div>
              <!--div class="ideas-box-item" v-for="(item, index) in tags"  v-on:mouseover="overMain('work', item.name[lang].name, sub)" v-on: v-on:mouseout="outMain('none')" v-on:click="goPage(3,item.name[lang].name )" ><span >{{item.name[lang].name}}</span></div-->
            </div>




          </div>
          <div class="agency-info-right ani-footer2" style="opacity: 0;" v-if="!isMobile">

            <div class="agency-info-social">
              <a href="https://www.facebook.com/NOSSA.agencia.publicidade" target="_blank" class="agency-info-social-ico agency-info-social-ico1"><Icons :id="'facebook'"></Icons></a>
              <a href="https://www.linkedin.com/company/NOSSA-/mycompany/" target="_blank" class="agency-info-social-ico agency-info-social-ico2"><Icons :id="'linkdin'"></Icons></a>
              <a href="https://www.instagram.com/NOSSA.oficial/" target="_blank" class="agency-info-social-ico agency-info-social-ico3"><Icons :id="'instagram'"></Icons></a>
              <a href="https://vimeo.com/NOSSAvideo" target="_blank" class="agency-info-social-ico agency-info-social-ico4"> <Icons :id="'vimeo'"></Icons></a>
              <a href="https://www.behance.net/NOSSAtmdes94f4" target="_blank" class="agency-info-social-ico agency-info-social-ico5"><Icons :id="'behance'"></Icons></a>

            </div>


          </div>
        </div>
        <div class="agency-info agency-info-mob"  v-if="isMobile">

          <div class="agency-info-social ani-footer5" style="opacity: 0;">
            <a href="https://www.facebook.com/NOSSA.agencia.publicidade" target="_blank" class="agency-info-social-ico agency-info-social-ico1"><Icons :id="'facebook'"></Icons></a>
            <a href="https://www.linkedin.com/company/NOSSA-/mycompany/" target="_blank" class="agency-info-social-ico agency-info-social-ico2"><Icons :id="'linkdin'"></Icons></a>
            <a href="https://www.instagram.com/NOSSA.oficial/" target="_blank" class="agency-info-social-ico agency-info-social-ico3"><Icons :id="'instagram'"></Icons></a>
            <a href="https://vimeo.com/NOSSAvideo" target="_blank" class="agency-info-social-ico agency-info-social-ico4"> <Icons :id="'vimeo'"></Icons></a>
            <a href="https://www.behance.net/NOSSAtmdes94f4" target="_blank" class="agency-info-social-ico agency-info-social-ico5"><Icons :id="'behance'"></Icons></a>

          </div>


        </div>

        <div class="agency-info">

          <div class="agency-info-left ani-footer2" style="opacity: 0;">
            <div class="agency-info-address">
              <div>Rua Mestre de Aviz 29 - Algés, Oeiras</div>
              <div><span>t </span><a href="tel:214000680" target="_blank">214 000 680</a> &nbsp;&nbsp; <span>e</span><a href="mailto:info@NOSSA.pt" target="_blank"></a> info@NOSSA.pt</div>
              <div  v-if="lang == 0" style="font-size: 0.7em; line-height: 1em;">(chamada para rede nacional)</div>
              <div  v-if="lang == 1" style="font-size: 0.7em; line-height: 1em;">(call to the landline network)</div>

            </div>
          </div>
          <div class="agency-info-right ani-footer4" style="opacity: 0;">

            <div class="agency-info-pp" v-if="!isMobile && lang == 0">
              <div><a href="https://nossa.pt/privacy-policy.pdf" target="_blank">Política de privacidade</a></div>
              <div> © NOSSA 2022. Todos os direitos reservados</div>
            </div>
            <div class="agency-info-pp" v-if="!isMobile && lang == 1">
              <div><a href="https://nossa.pt/privacy-policy.pdf" target="_blank">Privacy Policy</a></div>
              <div> © NOSSA 2022.All rights reserved</div>
            </div>
          </div>
        </div>






      </div>


      <div class="agency-info-pp ani-footer6" style="opacity: 0;" v-if="isMobile && lang == 0">
        <div><a href="https://nossa.pt/privacy-policy.pdf" target="_blank">Política de privacidade</a></div>
        <div> © NOSSA 2022. Todos os direitos reservados</div>
      </div>
      <div class="agency-info-pp ani-footer6" style="opacity: 0;" v-if="isMobile && lang == 1">
        <div><a href="https://nossa.pt/privacy-policy.pdf" target="_blank">Privacy Policy</a></div>
        <div> © NOSSA 2022. All rights reserved</div>
      </div>


    </footer>

</template>

<script>



    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP} from '../main';
    import Icons from "./Modules/Icons";



    export default {

        name: 'footer-nossa',
      components: {Icons},
      props: ['actRoute', 'isMobile', 'lang', 'big'],
        data() {
            return {

              loaded: false,
              ready: false,
              customersData: [],
              customersGroups: [],
              actualArr: [],
              actualArrCount: 0,
              pastArr: [],
              newArr: [],
              num: 6,
              fixedArr: [],
              inAnimItemArr:[],
              inAnimIconArr:[],
              tags:[],

              frameAnim: {}


            }
        },

        created() {
          const _this = this;
          if(_this.isMobile) {
            _this.num = 9;
          }



          WP('customers', function (response){
            let arrTemp = [];
            for(let k = 0; k < response.length; k ++) {


              if(!response[k].hidden){
                arrTemp.push(response[k])
              }


            }

            _this.customersData = _this.getShuffledArr(arrTemp);



           // console.log( _this.customersData )

            let countItems = 0;
            let countItems2 = 0;
            let countGroups = 0;
            _this.customersGroups[countGroups] = [];
            for(let i = 0; i < _this.customersData.length; i ++) {

              _this.customersData[i].id = i;


              if(countItems2 < 24){
                _this.fixedArr.push(i);

                countItems2++;
              }

              if(countItems < 6){


              }else {
                countItems = 0;
                countGroups ++;
                _this.customersGroups[countGroups] = [];
              }

              _this.customersGroups[countGroups].push(_this.customersData[i]);

              countItems ++
            }








            WP('tags', function (response2){
              _this.tags = response2;
              _this.loaded = true;
              _this.init();
            });
            // getShuffledArr
          });

        },
        mounted() {

          this.ready = true;
          this.init();
            EVENTBUS.$on('showFooter', this.showFooter);
            //EVENTBUS.$emit('AAA', 0);





        },

        destroyed() {
          console.log('destroyed');

          this.loaded = false;
          this.ready = false;
         // cancelAnimationFrame(this.frameAnim);

        },

        methods: {

          init() {
            const _this = this;

            if(_this.loaded && _this.ready){

              _this.getActualArr();



              setTimeout(function(){

                $('.customers-item').css('opacity', 0);

                setTimeout(function(){

                  if(_this.big === 'big'){

                    $(window).resize(function(){
                      _this.resizeMe();
                    });

                    _this.resizeMe();


                    _this.showFooter();
                  }

                }, 200);

              }, 10)


            }
          },


          resizeMe() {
            if(this.big === 'big'){


              /*



           //   let refItem = ((window.innerWidth * 1.1) + (window.innerHeight * 1.1)) / this.customersData.length;
              let refItem = $('.agency-info').width() / (this.customersData.length / 3);
              let refItemh = $('.agency-info').height() / (this.customersData.length * 0.07);


              $('.customers-item').width(refItem);
              $('.customers-item').height(refItemh);


               */


              if(!this.isMobile){
                let refH = window.innerHeight -  $('.agency-info').height() - 100;
                console.log(refH);
                $('.customers-ticker-big').height(refH);
              }
            //  this.frameAnim = requestAnimationFrame(this.resizeMe);

            }


          },

          getActualArr(){

            const _this = this;
            //this.actualArrCount

          //  this.actualArr = this.customersGroups[this.actualArrCount];

            this.changeArr();

          },


          getShuffledArr (arr){
            return [...arr].map( (_, i, arrCopy) => {
              var rand = i + ( Math.floor( Math.random() * (arrCopy.length - i) ) );
              [arrCopy[rand], arrCopy[i]] = [arrCopy[i], arrCopy[rand]]
              return arrCopy[i]
            })
          },


          showFooter(){

            var v = 2
            var d = 0;


            if(this.loaded){
              if(!this.big  ){
                for(let i = 0; i <=5; i++){
                  TweenMax.to('.customers-item' + i, v, {delay: d, force3D: true,  opacity: 1, ease:"circ.out"} );
                  d += 0.03;
                }
              }else{
                v = 1
                for(let i = 0; i <= this.customersData.length; i++){
                  TweenMax.to('.customers-item' + i, v, {delay: d, force3D: true,  opacity: 1, ease:"circ.out"} );
                  d += 0.01;
                }
              }


              ///AAAAAAAAAAAAAAAAAAAAAAAA
              ///AAAAAAAAAAAAAAAAAAAAAAAA
              ///AAAAAAAAAAAAAAAAAAAAAAAA
              ///AAAAAAAAAAAAAAAAAAAAAAAA
              ///AAAAAAAAAAAAAAAAAAAAAAAA
              ///AAAAAAAAAAAAAAAAAAAAAAAA


              for(let i = 1; i <=6; i++){
              //  TweenMax.to('.agency-info-partners-item' + i, v, {delay: d, force3D: true,  opacity: 1, ease:"circ.out"} );
                TweenMax.to('.ani-footer' + i, v, {delay: d, force3D: true,  opacity: 1, ease:"circ.out"} );
                d += 0.05;
              }




             // TweenMax.to('.agency-info-right' , v, {delay: d, force3D: true,  opacity: 1, ease:"circ.out"} );
             // TweenMax.to('.agency-info-pp' , v, {delay: d, force3D: true,  opacity: 1, ease:"circ.out"} );



              // if()

              if(!this.big){
                this.changeArr2();
              }
              if(this.big && !this.isMobile){
                this.initAnims();
              }
            }



          },


          changeArr(){

            const _this = this;
            if(_this.pastArr.length === 0){
              for(let i = 0; i < _this.customersData.length; i ++) {
                if(i < _this.num) {
                  _this.newArr.push(_this.customersData[i]);
                }
              }
            }else{
              _this.newArr = [];
              do{
                let it = _this.getItemArr();
                if(_this.existsPast(it)){
                  _this.newArr.push(it);
                }
              }while (_this.newArr.length < _this.num);
              _this.pastArr = [];
            }
            _this.pastArr  = _this.newArr;
          },

          getItemArr(){
            let tempArr = this.getShuffledArr(this.customersData);
            return tempArr[0];
          },

          existsPast(obj){
            let ret = true;
            for(let i = 0; i < this.pastArr.length; i ++) {
              if(obj == this.pastArr[i]){
                ret = false;
              }
            }
            for(let i = 0; i < this.newArr.length; i ++) {
              if(obj == this.newArr[i]){
                ret = false;
              }
            }
            return ret;
          },


          changeArr2(){

            const _this = this;



            let elTicker = document.querySelector('.customers-ticker');

            if(_this.isMobile){
              elTicker = document.querySelector('.customers-ticker-mob');
            }








            if(_this.loaded){
              TweenMax.to(elTicker , 1, {delay: 5, force3D: true,  opacity: 0, ease:"circ.In", onComplete: function(){


                  if(_this.loaded){
                    _this.changeArr();
                    TweenMax.to(elTicker, 1, {delay: 0.2, force3D: true,  opacity: 1, ease:"circ.Out", onComplete: function(){

                        if(_this.loaded){
                          _this.changeArr2();
                        }

                      }} );
                  }


                }} );
            }



          },



          /*************************************************************************************************************************
          /*************************************************************************************************************************
          /*************************************************************************************************************************
          /*************************************************************************************************************************/


          initAnims(){

            const _this = this;




            for(let i = 0; i < this.fixedArr.length; i ++) {

              $('#icon' + i + ' #inner' +  this.fixedArr[i]).css('opacity', 1);
            }

            setTimeout(
                function(){
               _this.randIco()
                }
            , 2000);





          },


          randNew(){

          },

          randIco(){
            const _this = this;

            let ico = _this.doIconPlace();
           let time =  _this.getRandomInt(50, 2000);
            _this.animItem(ico);


            setTimeout(function(){

              if(_this.loaded){
                _this.randIco();



              }

            }, time)




          },

          animItem(n){

            const _this = this;



            let pastIem = _this.fixedArr[n]
            _this.inAnimIconArr.push(n);
            _this.inAnimItemArr.push(pastIem);
         //  console.log( 'dddd: ' + _this.fixedArr[n]);
          // console.log( 'dddd: ' +  _this.inAnimItemArr);


            if(_this.loaded){
              TweenMax.to('#icon' + n + ' .inner-box' , 1, {force3D: true,  opacity: 0, scale: 0.9, ease:"circ.In", onComplete: function(){

                  // _this.arrRemove(_this.fixedArr, n);

                  let _new = _this.doIcon(_this.fixedArr[n])
                  //  console.log(_new);
                  _this.fixedArr[n] = _this.customersData[_new].id;

                  TweenMax.to('#icon' + n + ' #inner' +  _this.fixedArr[n], 1, {force3D: true, scale: 1,  opacity: 1, ease:"circ.Out", onComplete: function(){


                      _this.arrRemove(_this.inAnimIconArr, n);
                      _this.arrRemove(_this.inAnimItemArr, pastIem)

                    }} );
                }} );
            }


          },





          iconAvailable(){


          },


          doIcon(act){

            var newIcon = this.getRandomInt(0, (this.customersData.length - 1));
            var  loopNum = 0;
            do{
                newIcon =  this.getRandomInt(0, (this.customersData.length - 1))
                loopNum ++;
              // console.log('newIcon: ' + newIcon)
            }while (!this.existsIcon(act, newIcon, loopNum));

            //console.log('passou')
            return newIcon;
          },


          existsIcon(act, novo, loopNum){

           // console.log('existsIcon: ' + act + ' , '+  novo + ':  ' + loopNum)
        //   console.log('loopNum :' + loopNum)

            let ret = false;
            let ret1 = true;
            let ret2 = true;
            let ret3 = true;
            for(let i = 0; i < this.fixedArr.length; i ++) {
              if(novo == this.fixedArr[i] ){
                ret1 = false;
              }
            }
            for(let i = 0; i < this.inAnimItemArr.length; i ++) {
              if(novo == this.inAnimItemArr[i]  ){
                ret2 = false;
              }
            }
            if(act == novo){
              ret3 = false;
            }


            // console.log(ret1 + ' ' + ret2 + ' ' + ret3);
            if(ret1 && ret2 && ret3){
              ret = true;
            }

            if(loopNum > 100){
              ret = true;
         //     console.log('reco')
            }
            return ret;
          },




          doIconPlace(){

            let newIcon = 99999;
            do{
              newIcon =  this.getRandomInt(0, this.fixedArr.length)

            }while (!this.existsIconPlace(newIcon));




            return newIcon;
          },


          existsIconPlace(novo){

          //  console.log('existsIconPlace')

            let ret = true
            for(let i = 0; i < this.inAnimIconArr.length; i ++) {
              if(novo == this.inAnimIconArr[i] ){
                ret = false;
              }
            }

            return ret;
          },



          getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
          },



          arrRemove(arr, value){

            for(let i = 0; i < arr.length; i ++) {
              if(arr[i] == value) {
                arr.splice(i,1);


              }
            }




          },

          goPage(hash = ''){



            let route = '/ideas#' + hash;

            this.$router.push(route);



          },

          goAgencgy( ){

            let route = '/agency';
            this.$router.push(route);

          },

      }
    };

</script>


// WEBPACK FOOTER //
// src/components/FooterNossa.vue